import { FC, SVGProps } from 'react';
import { SvgIcon } from '../SvgIcon';

export const XIcon: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => {
	return (
		<SvgIcon viewBox='0 0 12 12' fill='none' {...props}>
			<path
				fill='currentColor'
				fillRule='evenodd'
				d='m12.228 1.202-.974-.974-5.026 5.025L1.202.228l-.974.974 5.026 5.026-5.026 5.025.974.974 5.026-5.024 5.026 5.024.974-.974-5.026-5.025 5.026-5.026Z'
				clipRule='evenodd'
			/>
		</SvgIcon>
	);
};
